import { Component, Input, input, OnInit } from '@angular/core';
import { StripePaymentRequestButtonComponent, StripeService } from 'ngx-stripe';
import {
  StripeElementsOptions,
  PaymentRequestPaymentMethodEvent,
  PaymentIntent,
  PaymentRequestShippingAddressEvent,
} from '@stripe/stripe-js';
import { Observable, of, switchMap } from 'rxjs';
import { StripeServiceAngular } from '../../service/stripe.service';

@Component({
    selector: 'app-reques-stripe-button',
    imports: [StripePaymentRequestButtonComponent],
    templateUrl: './reques-stripe-button.component.html',
    styleUrl: './reques-stripe-button.component.scss',
    standalone:true
})
export class RequesStripeButtonComponent implements OnInit {
  @Input() item: any;
  isButton = false;
  elementsOptions: StripeElementsOptions = {
    locale: 'es',
    currency: 'mxn',
  };
  paymentRequestOptions: any;
  constructor(
    private stripeService: StripeService,
    private stripeServiceAngular: StripeServiceAngular
  ) {
    
  }


  ngOnInit(): void {
    // this.paymentRequestOptions = {
    //   country: 'MX',
    //   currency: 'mxn',
    //   total: {
    //     label: `${this.item.name}`,
    //     amount: +this.item.total,
    //   },
    //   requestPayerName: true,
    //   requestPayerEmail: true,
    // }
    this.paymentRequestOptions = {
      country: 'MX',
      currency: 'mxn',
      total: {
        label: this.item?.name,
        amount: +`${this.item?.price_currency[0].regular_price!}00`,
      },
      requestPayerName: true,
      requestPayerEmail: true,
    };
    
    if (Object.keys(this.paymentRequestOptions).length >= 1) {
      this.isButton = true;
    }
    
  }
  onPaymentMethod(ev: PaymentRequestPaymentMethodEvent) {
    this.stripeServiceAngular.createPaymentIntent({ ammount: this.paymentRequestOptions.total.amount, description: this.item.name, client: '' })
      .pipe(
        switchMap((pi: any) => {
          return this.stripeService
            .confirmCardPayment(
              pi.client_secret,
              { payment_method: ev.paymentMethod.id },
              { handleActions: false }
            )
            .pipe(
              switchMap((confirmResult) => {
                if (confirmResult.error) {
                  // Report to the browser that the payment failed,
                  // prompting it to re-show the payment interface,
                  // or show an error message and close the payment.
                  ev.complete('fail');
                  return of({
                    error: new Error('Error Confirming the payment'),
                  });
                } else {
                  // Report to the browser that the confirmation was
                  // successful, prompting it to close the browser
                  // payment method collection interface.
                  ev.complete('success');
                  // Let Stripe.js handle the rest of the payment flow.
                  return this.stripeService.confirmCardPayment(
                    pi.client_secret
                  );
                }
              })
            );
        })
      )
      .subscribe((result) => {
        if (result.error) {
          // The payment failed -- ask your customer for a new payment method.
          
        } else {
          // The payment has succeeded.
          
        }
      });
  }
  onShippingAddressChange(ev: PaymentRequestShippingAddressEvent) {
    if (ev.shippingAddress.country !== 'US') {
      ev.updateWith({ status: 'invalid_shipping_address' });
    } else {
      // Replace this with your own custom implementation if needed
      fetch('/calculateShipping', {
        data: JSON.stringify({
          shippingAddress: ev.shippingAddress,
        }),
      } as any)
        .then((response) => response.json())
        .then((result) =>
          ev.updateWith({
            status: 'success',
            shippingOptions: result.supportedShippingOptions,
          })
        );
    }
  }
  onNotAvailable() {
    // Subscribe to this event in case you want to act
    // base on availability
    
  }
}
